import { render, staticRenderFns } from "./productPriceRuleManage.vue?vue&type=template&id=3d6c3994&scoped=true"
import script from "./productPriceRuleManage.vue?vue&type=script&lang=js"
export * from "./productPriceRuleManage.vue?vue&type=script&lang=js"
import style0 from "./productPriceRuleManage.vue?vue&type=style&index=0&id=3d6c3994&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d6c3994",
  null
  
)

export default component.exports